(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("aigoBot", [], factory);
	else if(typeof exports === 'object')
		exports["aigoBot"] = factory();
	else
		root["aigoBot"] = factory();
})(self, () => {
return 